export default "__VITE_ASSET__DUqx4bx___"